/** HA-753 — the first location to open the terminal at, or undefined when there are none. */
export function firstLocationId(
	app: { locations?: { id: string }[] } | null | undefined,
) {
	return app?.locations?.[0]?.id;
}
